<div
  class="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4"
  (click)="closePanel.emit()"
  aria-hidden="true"
>
  <div
    class="bg-white rounded-lg shadow-2xl w-full max-w-md border border-gray-200 overflow-hidden"
    (click)="$event.stopPropagation()"
    appModalDialog
    (dialogClose)="closePanel.emit()"
    role="dialog"
    aria-modal="true"
    aria-label="Compare with another session"
  >
    <div class="px-4 py-3 border-b border-gray-200 bg-gray-50 flex items-center gap-2">
      <i class="ri-git-compare-line text-primary"></i>
      <h2 class="text-base font-semibold text-gray-800">Compare with another session</h2>
      <button
        class="ml-auto text-gray-400 hover:text-gray-600"
        (click)="closePanel.emit()"
        aria-label="Close"
      >
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="p-4 space-y-3">
      <div class="text-sm text-gray-700">
        Comparing
        <span class="font-mono text-xs bg-gray-100 px-1.5 py-0.5 rounded break-all">
          {{ sessionAValue }}
        </span>
        against:
      </div>

      <label class="block">
        <span class="text-xs uppercase text-gray-500 tracking-wider">Session ID</span>
        <input
          type="text"
          autofocus
          placeholder="sess-…"
          class="mt-1 w-full pl-3 pr-2 py-1.5 text-sm font-mono rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-300"
          [(ngModel)]="sessionBValue"
          (keydown)="onInputKeydown($event)"
        />
      </label>

      <div class="text-xs text-gray-500">
        Tip: press
        <kbd class="kbd kbd-xs">⌘</kbd>
        /
        <kbd class="kbd kbd-xs">Ctrl</kbd>
        +
        <kbd class="kbd kbd-xs">Enter</kbd>
        to run.
      </div>
    </div>

    <div class="px-4 py-3 border-t border-gray-200 bg-gray-50 flex items-center justify-end gap-2">
      <button class="btn btn-sm btn-ghost" (click)="closePanel.emit()">Cancel</button>
      <button
        class="btn btn-sm btn-primary"
        [disabled]="!sessionBValue.trim() || sessionBValue.trim() === sessionAValue"
        (click)="runDiff()"
      >
        Run diff
        <i class="ri-arrow-right-line ml-1"></i>
      </button>
    </div>
  </div>
</div>
